import React, { lazy, Suspense, useContext } from 'react';
import { getTenant } from '../../../Utils/storageUtils';
import { TenantType } from '../../../Utils/types';
import NativeLoader from '../../NativeLoader';
import { AppContext } from '../../../App';

const PBStocks = lazy(() => import('../../PaisaBazaar/Stocks'));
const PBStocksNewFlow = lazy(() => import('../../PaisaBazaar/StocksNewFlow'));
const JFSStocksETFs = lazy(() => import('../../JFS/StocksETFs'));
const AUStocksNewFlow = lazy(() => import('../../AUBank/StocksNewFlow'));

interface StocksProps {
  onHoldingClick?: (holding: any) => void;

}

const Stocks: React.FC<StocksProps> = ({ onHoldingClick }) => {
  const tenant = getTenant();
  const {data} : any= useContext(AppContext);

  console.log("inside wrapper stock of " , tenant , TenantType.AU);
  console.log(data.current.totalPortfolioValue);

  const renderTenantSpecificStocks = () => {
    switch (tenant) {
      case TenantType.PB:
        return data?.current?.totalPortfolioValue ? (
          <PBStocksNewFlow onHoldingClick={onHoldingClick} />
        ) : (
          <PBStocks />
        );

      case TenantType.JFS:
        return <JFSStocksETFs />;

      case TenantType.AU:
        return <AUStocksNewFlow onHoldingClick={onHoldingClick} />
       

      case TenantType.YESBANK:
      case TenantType.MAHINDRA:
      default:
        return <PBStocks />;
    }
  };

  return (
    <Suspense fallback={<NativeLoader />}>
      {renderTenantSpecificStocks()}
    </Suspense>
  );
};

export default Stocks;